import { render, staticRenderFns } from "./LiveVehicleTable.vue?vue&type=template&id=70472c94"
import script from "./LiveVehicleTable.vue?vue&type=script&lang=js"
export * from "./LiveVehicleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports